import { render, staticRenderFns } from "./CampaignActionsDelete.vue?vue&type=template&id=23d1529a&lang=pug&"
import script from "./CampaignActionsDelete.vue?vue&type=script&lang=js&"
export * from "./CampaignActionsDelete.vue?vue&type=script&lang=js&"
import style0 from "./CampaignActionsDelete.vue?vue&type=style&index=0&id=23d1529a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports